import React from 'react'

import styles from './NewAddressOption.module.css'

export const NewAddressOption = () => (
  <span className={styles.newAddress}>Enter a new address...</span>
)
